var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "130px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Doc"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t("PreoccupationManagement.Doc"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Channel"),
                          prop: "channel",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "lov-code": "SCHL.CHANNEL_TYPE",
                            placeholder: _vm.$t(
                              "PreoccupationManagement.Channel"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.channel,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "channel", $$v)
                            },
                            expression: "queryParams.channel",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Store"),
                          prop: "storeId",
                        },
                      },
                      [
                        _c("BjSelectStore", {
                          attrs: {
                            placeholder: _vm.$t(
                              "PreoccupationManagement.Store"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "storeId", $$v)
                            },
                            expression: "queryParams.storeId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Pre"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list":
                              _vm.ORDER_ADVANCE_PREEMPT_STATUS_LIST,
                            placeholder: _vm.$t("PreoccupationManagement.Pre"),
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Three"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "PreoccupationManagement.Three"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Internal"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "PreoccupationManagement.Internal"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.ORDER_ADVANCE_PREEMPT_STATUS_LIST.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "code"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDetail(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            staticClass: "ml10",
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessThirdOrderView(
                                                    scope.row.outerOrderNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "innerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessOrderInternalView(
                                                    scope.row.innerOrderNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "channel"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.SCHL_CHANNEL_TYPE.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }